import React, { useEffect, useState } from "react";
import { Link, useStaticQuery, graphql } from 'gatsby';
import { Container, Navbar, Nav, NavDropdown, Image, Dropdown, Row, Col } from 'react-bootstrap';

import logo from '../images/logo.svg';
import logoWhite from '../images/logo-white.svg';
import LiveWebinar from '../images/icon/live-webinar.svg'
import yelowetaxiSMlogo from '../images/yelowtaxi-sm-logo.svg';
import yelowexpressSMlogo from '../images/yelowexpress-sm-logo.svg';

import flagAr from '../images/country/sa.svg';
import flagEn from '../images/country/us.svg';
import flagFr from '../images/country/fr.svg';
import flagPt from '../images/country/pt.svg';
import flagEs from '../images/country/es.svg';
import Web from '../images/icon/web-booking.svg';

import Kiosk from '../images/icon/kiosk-app.svg';
import Portal from '../images/icon/account-portal.svg';
import Cms from '../images/icon/web-cms.svg';
import Digital from '../images/icon/digital-marketing.svg';
import Rental from '../images/icon/car-rental.svg';
import Cab from '../images/icon/cab-companey.svg';


// import yelowetaxi from '../images/yelowtaxi-logo.svg';
import yelowexpressnew from '../images/yelowexpress-logo.svg';

import Airport from '../images/icon/airport-menu.svg';
import CorporateTransfer from '../images/icon/corporate-transfer-menu.svg';
import RideHailing from '../images/icon/ride-hailing-menu.svg';
import Dispatch from '../images/icon/dispatch-menu.svg';
import Dispatchplatform from '../images/icon/dispatch-platform.svg';
import Limo from '../images/icon/suv.svg';
import Carerentalicon1 from '../images/icon/bus.svg';
import Limodriver from '../images/icon/limo-driver.svg';
import Startup from '../images/icon/private-oprator.svg';
import Operators from '../images/icon/startup.svg';


// import Admin from '../images/icon/admin-menu.svg';
import User from '../images/icon/user-menu.svg';
import Dispatcher from '../images/icon/dispatcher-menu.svg';
import Driver from '../images/icon/driver-menu.svg';


const Header = ({ yelowtaxi, yelowexpress, showmarquess = false }) => {

    // const flag = { flagAr, flagEn, flagFr, flagPt, flagEs }

    // const [showDropdownHover1, setShowDropdown1] = useState(false);
    const [showDropdownHover2, setShowDropdown2] = useState(false);
    const [showDropdownHover3, setShowDropdown3] = useState(false);
    const [showDropdownHover4, setShowDropdown4] = useState(false);
    const [showDropdownHover5, setShowDropdown5] = useState(false);
    const [showDropdownHover6, setShowDropdown6] = useState(false);
    const [showDropdownHover7, setShowDropdown7] = useState(false);

    // const [showFeatureInnerDropdownHover1, setShowFeatureInnerDropdown1] = useState(false);
    const [showFeatureInnerDropdownHover2, setShowFeatureInnerDropdown2] = useState(false);
    const [showFeatureInnerDropdownHover3, setShowFeatureInnerDropdown3] = useState(false);
    const [showFeatureInnerDropdownHover4, setShowFeatureInnerDropdown4] = useState(false);

    const [showDropdownHover1Topbar, setShowDropdown1Topbar] = useState(false);

    const showDropdown1Topbar = (e) => { setShowDropdown1Topbar(!showDropdownHover1Topbar); }
    const hideDropdown1Topbar = e => { setShowDropdown1Topbar(false); }

    // const showDropdown1 = (e) => { setShowDropdown1(!showDropdownHover1); }
    // const hideDropdown1 = e => { setShowDropdown1(false); }

    const showDropdown2 = (e) => { setShowDropdown2(!showDropdownHover2); }
    const hideDropdown2 = e => { setShowDropdown2(false); }

    const showDropdown3 = (e) => { setShowDropdown3(!showDropdownHover3); }
    const hideDropdown3 = e => { setShowDropdown3(false); }

    const showDropdown4 = (e) => { setShowDropdown4(!showDropdownHover4); }
    const hideDropdown4 = e => { setShowDropdown4(false); }

    const showDropdown5 = (e) => { setShowDropdown5(!showDropdownHover5); }
    const hideDropdown5 = e => { setShowDropdown5(false); }

    const showDropdown6 = (e) => { setShowDropdown6(!showDropdownHover6); }
    const hideDropdown6 = e => { setShowDropdown6(false); }

    const showDropdown7 = (e) => { setShowDropdown7(!showDropdownHover7); }
    const hideDropdown7 = e => { setShowDropdown7(false); }

    // const showFeatureInnerDropdown1 = (e) => { setShowFeatureInnerDropdown1(!showFeatureInnerDropdownHover1); }
    // const hideFeatureInnerDropdown1 = e => { setShowFeatureInnerDropdown1(false); }

    const showFeatureInnerDropdown2 = (e) => { setShowFeatureInnerDropdown2(!showFeatureInnerDropdownHover2); }
    const hideFeatureInnerDropdown2 = e => { setShowFeatureInnerDropdown2(false); }

    const showFeatureInnerDropdown3 = (e) => { setShowFeatureInnerDropdown3(!showFeatureInnerDropdownHover3); }
    const hideFeatureInnerDropdown3 = e => { setShowFeatureInnerDropdown3(false); }

    const showFeatureInnerDropdown4 = (e) => { setShowFeatureInnerDropdown4(!showFeatureInnerDropdownHover4); }
    const hideFeatureInnerDropdown4 = e => { setShowFeatureInnerDropdown4(false); }

    const [scroll, setScroll] = useState(false);
    const [language, setLanguage] = useState('EN');
    // const [flagUpdate, setflagUpdate] = useState(flag.flagEn);

    var comboGoogleTradutor = null;

    const googleTranslateElementInit = () => {
        new window.google.translate.TranslateElement({ pageLanguage: 'en', includedLanguages: 'ar,en,fr,pt,es', layout: window.google.translate.TranslateElement.InlineLayout.HORIZONTAL }, 'google_translate_element');
    };

    useEffect(() => {
        const addScript = () => {
            const script = document.createElement('script');
            script.defer = true;
            script.setAttribute('src', 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit');
            document.body.appendChild(script);
            window.googleTranslateElementInit = googleTranslateElementInit;
        };

        const loadScriptWithDelay = () => {
            return setTimeout(addScript, 10000); // Store the timeout ID
        };

        const timeoutId = loadScriptWithDelay(); // Store the timeout ID returned by setTimeout

        // Cleanup the timeout when the component unmounts
        return () => {
            clearTimeout(timeoutId); // Clear the timeout using the stored ID
        };

    }, []);

    const changeEvent = (el) => {
        if (el.fireEvent) {
            el.fireEvent('onchange');
        } else {
            const event = document.createEvent("HTMLEvents");
            event.initEvent("change", true, false);
            el.dispatchEvent(event);
        }
    };

    const handleClick = (lang) => {

        setLanguage(lang);

        comboGoogleTradutor = document.getElementById("google_translate_element").querySelector(".goog-te-combo");
        if (comboGoogleTradutor) {
            comboGoogleTradutor.value = lang;
            changeEvent(comboGoogleTradutor);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 150);
        });
    }, []);

    // const [showScheduleCall, setScheduleCall] = useState(false);

    // const handleShowScheduleCall = () => setScheduleCall(true);
    // const handleCloseScheduleCall = () => setScheduleCall(false);


    const data = useStaticQuery(graphql`
        query {
            allFeatureJson {
                edges {
                    node {
                        id
                        slug
                        category
                        headername                
                    }
                }
            }
        }
    `);

    const posts = data.allFeatureJson.edges;
    // const filteredPostsAdmin = posts.filter(post => post.node.category === 'admin');
    const filteredPostsPassenger = posts.filter(post => post.node.category === 'passenger-app');
    const filteredPostsDispatcher = posts.filter(post => post.node.category === 'dispatcher-app');
    const filteredPostsDriver = posts.filter(post => post.node.category === 'driver-app');

    return (
        <>
            <div id="google_translate_element" className="boxTradutor"></div>
            {showmarquess ?
                <div width="100%" direction="left" height="20px" className="marquee">
                    <div className="me-2 d-inline-block" style={{ marginTop: '-10px', marginBottom: '-10px', verticalAlign: 2 }}>
                        <Image loading="lazy" className="lazyload" src={LiveWebinar} width={44} height={44} alt="yelwosoft" />
                    </div>
                    Live webinar: Discover Yelowsoft and find out how to enhance customer experience in the taxi industry through technology
                    <i className="zmdi zmdi-chevron-right mx-2"></i> <Link to="/webinars">Register now for free</Link>
                    {/* <a href="https://app.livewebinar.com/584-523-489" aria-label="Watch Now" rel="noreferrer" target="_blank">Register for free</a> */}
                </div >
                : null}
            {/* { (yelowtaxi || yelowexpress) ? */}
            <div className="topbar py-1">
                <Container className="d-flex align-items-center">
                    {/* <Link to="/" className="logo-small">
                        <Image loading="lazy" className="logo-color lazyload" src={logo} width={100} height={20} alt="yelwosoft" />
                    </Link> */}

                    {/* <a aria-label="Whatsapp Chat" href="https://wa.me/919725496144" rel="noreferrer" target="_blank" className="topbar-link d-none d-md-flex align-items-center">
                        <div className="icon me-2">
                            <i className="zmdi zmdi-hc-lg zmdi-whatsapp"></i>
                        </div>
                        Whatsapp Chat
                    </a> */}
                    {/* <div role="button" tabIndex="0" onClick={handleShowScheduleCall} onKeyDown={handleShowScheduleCall} className="topbar-link d-flex d-lg-none align-items-center">
                        <div className="icon me-2">
                            <i className="zmdi zmdi-hc-lg zmdi-phone"></i>
                        </div>
                        Schedule Call
                    </div> */}
                    <a href="/demo" className="topbar-link d-flex d-lg-none align-items-center" aria-label="Book a demo" rel="noreferrer" target="_blank">
                        <div className="icon me-2">
                            <i className="zmdi zmdi-hc-lg zmdi-phone"></i>
                        </div>
                        Book a demo
                    </a>
                    <span className="flex-fill"></span>
                    <Dropdown
                        show={showDropdownHover4}
                        onMouseEnter={showDropdown4}
                        onMouseLeave={hideDropdown4}
                        onClick={showDropdown4}
                    >
                        <Dropdown.Toggle as="a" href="#" id="basic-nav-language" className="text-uppercase d-flex align-items-center topbar-link notranslate 0ps-0">
                            {/* <Image loading="lazy" className="lazyload rounded me-2" src={flagUpdate} alt={language} width={24} height={18} /> */}
                            <div className="icon me-2">
                                <i className="zmdi zmdi-hc-lg zmdi-globe-alt"></i>
                            </div>
                            {language}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="switcher notranslate">
                            <div className="gtranslate-dropdown">
                                <Link to="" className="dropdown-item d-flex align-items-center" onClick={(e) => { handleClick('ar'); }}>
                                    <Image loading="lazy" className="lazyload rounded me-2" src={flagAr} width={24} height={18} alt="ar" /> AR
                                </Link>
                                <Link to="" className="dropdown-item d-flex align-items-center" onClick={(e) => { handleClick('en'); }}>
                                    <Image loading="lazy" className="lazyload rounded me-2" src={flagEn} width={24} height={18} alt="en" /> EN
                                </Link>
                                <Link to="" className="dropdown-item d-flex align-items-center" onClick={(e) => { handleClick('fr'); }}>
                                    <Image loading="lazy" className="lazyload rounded me-2" src={flagFr} width={24} height={18} alt="fr" /> FR
                                </Link>
                                <Link to="" className="dropdown-item d-flex align-items-center" onClick={(e) => { handleClick('pt'); }}>
                                    <Image loading="lazy" className="lazyload rounded me-2" src={flagPt} width={24} height={18} alt="pt" /> PT
                                </Link>
                                <Link to="" className="dropdown-item d-flex align-items-center" onClick={(e) => { handleClick('es'); }}>
                                    <Image loading="lazy" className="lazyload rounded me-2" src={flagEs} width={24} height={18} alt="es" /> ES
                                </Link>
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                    {yelowexpress ?
                        <Dropdown align="end"
                            show={showDropdownHover1Topbar}
                            onMouseEnter={showDropdown1Topbar}
                            onMouseLeave={hideDropdown1Topbar}
                            onClick={showDropdown1Topbar}
                            className="resources-menu"
                        >
                            <Dropdown.Toggle as="a" href="#" id="basic-nav-products-topbar" className="topbar-link">Products</Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Link to="/taxi-dispatch-software" className="dropdown-item p-3">
                                    <Image loading="lazy" className="lazyload me-3" src={yelowetaxiSMlogo} width={60} height={60} alt="yelowtaxi" />
                                    <div>
                                        <p className="menu-text fw-medium">YelowTaxi</p>
                                        <span className="font-size-14 text-muted">Streamline your taxi dispatch operations</span>
                                    </div>
                                </Link>
                                <Link to="/online-ordering-and-delivery-software" className="dropdown-item p-3">
                                    <Image loading="lazy" className="lazyload me-3" src={yelowexpressSMlogo} width={60} height={60} alt="yelowexpress" />
                                    <div>
                                        <p className="menu-text fw-medium">YelowXpress</p>
                                        <span className="font-size-14 text-muted">On-demand delivery made easy with YelowXpress</span>
                                    </div>
                                </Link>
                            </Dropdown.Menu>
                        </Dropdown>
                        : null
                    }
                    <Link to="/support-center" className="topbar-link d-none d-md-flex align-items-center">Customer Support</Link>
                    <Dropdown align="end"
                        show={showDropdownHover5}
                        onMouseEnter={showDropdown5}
                        onMouseLeave={hideDropdown5}
                        onClick={showDropdown5}
                        className="customer-support"
                    >
                        <Dropdown.Toggle as="a" href="#" id="basic-nav-company" className="topbar-link">Company</Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Link to="/our-story" className="dropdown-item">Our Story</Link>
                            {/* <Link to="/our-usps" className="dropdown-item">Our USPs</Link> */}
                            <Link to="/why-yelowsoft" className="dropdown-item">Why Yelowsoft</Link>
                            <Link to="/our-clients" className="dropdown-item">Our Clients</Link>
                            <Link to="/testimonials" className="dropdown-item">Testimonials</Link>
                            <Link to="/support-center" className="dropdown-item">Support</Link>
                        </Dropdown.Menu>
                    </Dropdown>
                </Container>
            </div>
            {/* : null } */}
            <Navbar variant="light" expand="lg" className={scroll ? "navbar-fixed" : ""}>
                <Container className="flex-nowrap">
                    {yelowtaxi ? (
                        <Navbar.Brand className="me-lg-5">
                            <Link to="/">
                                <Image loading="lazy" className="logo-color lazyload" src={logo} width={155} height={30} alt="yelwosoft" />
                                <Image loading="lazy" className="logo-white lazyload" src={logoWhite} width={155} height={30} alt="yelwosoft" />
                            </Link>
                        </Navbar.Brand>
                        // <Navbar.Brand className="me-lg-5">
                        //     <Link to="/taxi-dispatch-software">
                        //         <Image loading="lazy" className="lazyload" src={yelowetaxi} width={150} height={30} alt="yelowtaxi" />
                        //     </Link >
                        // </Navbar.Brand >
                    ) : yelowexpress ? (
                        <Navbar.Brand className="me-lg-5">
                            <Link to="/online-ordering-and-delivery-software">
                                <Image loading="lazy" className="lazyload" src={yelowexpressnew} width={150} height={30} alt="yelowexpress" />
                            </Link>
                        </Navbar.Brand>
                    ) :
                        <Navbar.Brand className="me-lg-5">
                            <Link to="/">
                                <Image loading="lazy" className="logo-color lazyload" src={logo} width={155} height={30} alt="yelwosoft" />
                                <Image loading="lazy" className="logo-white lazyload" src={logoWhite} width={155} height={30} alt="yelwosoft" />
                            </Link>
                        </Navbar.Brand>
                    }
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="align-items-center navbar-nav flex-fill">
                            {/* {
                                (yelowtaxi || yelowexpress) ?
                                    null :
                                    <NavDropdown title="Products" id="basic-nav-products" className="resources-menu mega-menu"
                                        show={showDropdownHover1}
                                        onMouseEnter={showDropdown1}
                                        onMouseLeave={hideDropdown1}
                                        onClick={showDropdown1}
                                    >
                                        <Link to="/taxi-dispatch-software" className="dropdown-item p-3">
                                            <Image loading="lazy" className="lazyload me-3" src={yelowetaxiSMlogo} width={60} height={60} alt="yelowetaxiSMlogo" />
                                            <div>
                                                <p className="menu-text fw-medium">YelowTaxi</p>
                                                <span className="font-size-14 text-muted">Streamline your taxi dispatch operations</span>
                                            </div>
                                        </Link>
                                        <Link to="/online-ordering-and-delivery-software" className="dropdown-item p-3">
                                            <Image loading="lazy" className="lazyload me-3" src={yelowexpressSMlogo} width={60} height={60} alt="yelowexpressSMlogo" />
                                            <div>
                                                <p className="menu-text fw-medium">YelowXpress</p>
                                                <span className="font-size-14 text-muted">On-demand delivery made easy with YelowXpress</span>
                                            </div>
                                        </Link>
                                    </NavDropdown>
                            } */}
                            {!yelowexpress ?
                                <NavDropdown
                                    title="Products"
                                    id="basic-nav-features"
                                    show={showDropdownHover6}
                                    onMouseEnter={showDropdown6}
                                    onMouseLeave={hideDropdown6}
                                    // onClick={showDropdown6}
                                    className="resources-menu mega-menu-business-type"
                                >

                                    <Row xs={1} lg={2} className="g-0">
                                        <Col>
                                            <div className="border-end pe-lg-4 me-lg-4 equal-height">
                                                <Link to="/taxi-booking-software" className="dropdown-item pb-3">
                                                    <div className="icon-size-50 yellow-rounded-circle me-3">
                                                        <Image loading="lazy" className="lazyload" src={Dispatch} width={28} height={28} alt="dispatcher" />
                                                    </div>
                                                    <div>
                                                        <p className="menu-text">Booking Software</p>
                                                        <span className="font-size-12 text-muted">Centralize bookings - app, web, kiosk</span>
                                                    </div>
                                                </Link>
                                                <Link to="/taxi-dispatch-platform" className="dropdown-item pb-3">
                                                    <div className="icon-size-50 yellow-rounded-circle me-3">
                                                        <Image loading="lazy" className="lazyload" src={Dispatchplatform} width={30} height={30} alt="dispatch" />
                                                    </div>
                                                    <div>
                                                        <p className="menu-text">Dispatch Platform</p>
                                                        <span className="font-size-12 text-muted">Real time automated ride allotment</span>
                                                    </div>
                                                </Link>
                                                {filteredPostsDispatcher.length > 4 ? (
                                                    <Dropdown show={showFeatureInnerDropdownHover4}
                                                        onMouseEnter={showFeatureInnerDropdown4}
                                                        onMouseLeave={hideFeatureInnerDropdown4}
                                                        onClick={showFeatureInnerDropdown4}
                                                        id="basic-nav-dispatcher" drop="end">
                                                        <Dropdown.Toggle as={Dropdown.Item}>
                                                            <div className="icon-size-50 yellow-rounded-circle me-3">
                                                                <Image loading="lazy" className="lazyload" src={Dispatcher} width={28} height={28} alt="dispatcher" />
                                                            </div>
                                                            <div>
                                                                <p className="menu-text">Dispatcher App</p>
                                                                <span className="font-size-12 text-muted">Assign, track & manage rides</span>
                                                            </div>
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <div className="h-100 d-flex flex-column">
                                                                <Row xs={1} lg={2} className="g-2 mb-auto">

                                                                    {filteredPostsDispatcher.map((post, index) => {
                                                                        const basePath = post.node.category ? `/${post.node.category}` : '';
                                                                        return (
                                                                            <Col key={post.node.id || index}>
                                                                                <Link to={`${basePath}/${post.node.slug}`} className="dropdown-item">{post.node.headername}</Link>
                                                                            </Col>
                                                                        );
                                                                    })}
                                                                </Row>
                                                                {/* <div className="d-grid border-top mt-3 p-3 p-lg-0 pt-lg-4">
                                                        <Link to="/features" className="btn btn-primary-theme-light btn-lg">See all features <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-chevron-right"></i></Link>
                                                    </div> */}
                                                            </div>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                ) : (
                                                    <Link to="/dispatcher" className="dropdown-item pb-3">
                                                        <div className="icon-size-50 yellow-rounded-circle me-3">
                                                            <Image loading="lazy" className="lazyload" src={Dispatcher} width={28} height={28} alt="dispatcher" />
                                                        </div>
                                                        <div>
                                                            <p className="menu-text">Dispatcher App</p>
                                                            <span className="font-size-12 text-muted">Assign, track & manage rides</span>
                                                        </div>
                                                    </Link>
                                                )}
                                                {filteredPostsDriver.length > 4 ? (
                                                    <Dropdown show={showFeatureInnerDropdownHover3}
                                                        onMouseEnter={showFeatureInnerDropdown3}
                                                        onMouseLeave={hideFeatureInnerDropdown3}
                                                        onClick={showFeatureInnerDropdown3}
                                                        id="basic-nav-driver" drop="end">
                                                        <Dropdown.Toggle as={Dropdown.Item}>
                                                            <div className="icon-size-50 yellow-rounded-circle me-3">
                                                                <Image loading="lazy" className="lazyload" src={Driver} width={28} height={28} alt="driver" />
                                                            </div>
                                                            <div>
                                                                <p className="menu-text">Driver/chauffeur App</p>
                                                                <span className="font-size-12 text-muted">Driver's trips, earnings & schedule</span>
                                                            </div>
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <div className="h-100 d-flex flex-column">
                                                                <Row xs={1} lg={2} className="g-2 mb-auto">

                                                                    {filteredPostsDriver.map((post, index) => {
                                                                        const basePath = post.node.category ? `/${post.node.category}` : '';
                                                                        return (
                                                                            <Col key={post.node.id || index}>
                                                                                <Link to={`${basePath}/${post.node.slug}`} className="dropdown-item">{post.node.headername}</Link>
                                                                            </Col>
                                                                        );
                                                                    })}
                                                                </Row>
                                                                {/* <div className="d-grid border-top mt-3 p-3 p-lg-0 pt-lg-4">
                                                        <Link to="/features" className="btn btn-primary-theme-light btn-lg">See all features <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-chevron-right"></i></Link>
                                                    </div> */}
                                                            </div>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                ) : (
                                                    <Link to="/driver-app" className="dropdown-item pb-3">
                                                        <div className="icon-size-50 yellow-rounded-circle me-3">
                                                            <Image loading="lazy" className="lazyload" src={Driver} width={28} height={28} alt="driver" />
                                                        </div>
                                                        <div>
                                                            <p className="menu-text">Driver/chauffeur App</p>
                                                            <span className="font-size-12 text-muted">Driver's trips, earnings & schedule</span>
                                                        </div>
                                                    </Link>
                                                )}
                                                {filteredPostsPassenger.length > 4 ? (
                                                    <Dropdown show={showFeatureInnerDropdownHover2}
                                                        onMouseEnter={showFeatureInnerDropdown2}
                                                        onMouseLeave={hideFeatureInnerDropdown2}
                                                        onClick={showFeatureInnerDropdown2}
                                                        id="basic-nav-user" drop="end">
                                                        <Dropdown.Toggle as={Dropdown.Item}>
                                                            <div className="icon-size-50 yellow-rounded-circle me-3">
                                                                <Image loading="lazy" className="lazyload" src={User} width={27} height={27} alt="user" />
                                                            </div>
                                                            <div>
                                                                <p className="menu-text">Passenger App</p>
                                                                <span className="font-size-12 text-muted">Book, track and pay for rides</span>
                                                            </div>
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <div className="h-100 d-flex flex-column">
                                                                <Row xs={1} lg={2} className="g-2 mb-auto">

                                                                    {filteredPostsPassenger.map((post, index) => {
                                                                        const basePath = post.node.category ? `/${post.node.category}` : '';
                                                                        return (
                                                                            <Col key={post.node.id || index}>
                                                                                <Link to={`${basePath}/${post.node.slug}`} className="dropdown-item">{post.node.headername}</Link>
                                                                            </Col>
                                                                        );
                                                                    })}
                                                                </Row>
                                                                {/* <div className="d-grid border-top mt-3 p-3 p-lg-0 pt-lg-4">
                                                        <Link to="/features" className="btn btn-primary-theme-light btn-lg">See all features <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-chevron-right"></i></Link>
                                                    </div> */}
                                                            </div>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                ) : (
                                                    <Link to="/passenger-app" className="dropdown-item pb-3">
                                                        <div className="icon-size-50 yellow-rounded-circle me-3">
                                                            <Image loading="lazy" className="lazyload" src={User} width={27} height={27} alt="user" />
                                                        </div>
                                                        <div>
                                                            <p className="menu-text">Passenger App</p>
                                                            <span className="font-size-12 text-muted">Book, track and pay for rides</span>
                                                        </div>
                                                    </Link>
                                                )}
                                                <Link to="/web-based-taxi-booking-system" className="dropdown-item">
                                                    <div className="icon-size-50 yellow-rounded-circle me-3">
                                                        <Image loading="lazy" className="lazyload" src={Web} width={30} height={30} alt="dispatcher" />
                                                    </div>
                                                    <div>
                                                        <p className="menu-text">Web Booking Engine</p>
                                                        <span className="font-size-12 text-muted">Web-integrated ride booking tool</span>
                                                    </div>
                                                </Link>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="equal-height">


                                                <Link to="/web-kiosk-app-hotels-restaurants-receptions" className="dropdown-item pb-3">
                                                    <div className="icon-size-50 yellow-rounded-circle me-3">
                                                        <Image loading="lazy" className="lazyload" src={Kiosk} width={30} height={30} alt="dispatch" />
                                                    </div>
                                                    <div>
                                                        <p className="menu-text">Kiosk/Concierge App</p>
                                                        <span className="font-size-12 text-muted">Ride booking partner app for hotels and kiosks</span>
                                                    </div>
                                                </Link>
                                                <div className="dropdown-item pb-3 non-link">
                                                    <div className="icon-size-50 yellow-rounded-circle me-3">
                                                        <Image loading="lazy" className="lazyload" src={Portal} width={30} height={30} alt="dispatch" />
                                                    </div>
                                                    <div>
                                                        <p className="menu-text">Accounts Portal</p>
                                                        <span className="font-size-12 text-muted">Create and manage corporate accounts






</span>
                                                    </div>
                                                </div>
                                                <div className="dropdown-item pb-3 non-link">
                                                    <div className="icon-size-50 yellow-rounded-circle me-3">
                                                        <Image loading="lazy" className="lazyload" src={Cms} width={30} height={30} alt="dispatch" />
                                                    </div>
                                                    <div>
                                                        <p className="menu-text">Website CMS</p>
                                                        <span className="font-size-12 text-muted">Build your taxi business website with no coding</span>
                                                    </div>
                                                </div>
                                                <div className="dropdown-item pb-3 non-link">
                                                    <div className="icon-size-50 yellow-rounded-circle me-3">
                                                        <Image loading="lazy" className="lazyload" src={Digital} width={30} height={30} alt="dispatch" />
                                                    </div>
                                                    <div>
                                                        <p className="menu-text">Digital Marketing Tools</p>
                                                        <span className="font-size-12 text-muted">Build your taxi brand and boost bookings</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>




                                    {/* {filteredPostsAdmin.length > 4 ? (
                                        <Dropdown show={showFeatureInnerDropdownHover1}
                                            onMouseEnter={showFeatureInnerDropdown1}
                                            onMouseLeave={hideFeatureInnerDropdown1}
                                            onClick={showFeatureInnerDropdown1}
                                            id="basic-nav-admin" drop="end">
                                            <Dropdown.Toggle as={Dropdown.Item}>
                                                <div className="icon-size-50 yellow-rounded-circle me-3">
                                                    <Image loading="lazy" className="lazyload" src={Admin} width={25} height={28} alt="admin" />
                                                </div>
                                                <div>
                                                    <p className="menu-text">Booking and dispatch</p>
                                                    <span className="font-size-12 text-muted">Efficiently manage taxi business</span>
                                                </div>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <div className="flex-fill d-flex flex-column">
                                                    <Row xs={1} lg={2} className="g-2 mb-auto">
                                                        {filteredPostsAdmin.map((post, index) => {
                                                            const basePath = post.node.category ? `/${post.node.category}` : '';
                                                            return (
                                                                <>
                                                                    <Col key={post.node.id || index} className={post.node.slug === "corporate-account-management" ? "order-last" : null} lg={post.node.slug === "corporate-account-management" ? 7 : null}>
                                                                        <Link to={`${basePath}/${post.node.slug}`} className="dropdown-item">{post.node.headername}</Link>
                                                                    </Col>
                                                                </>
                                                            );
                                                        })}
                                                    </Row>
                                                </div>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        ) : (
                                        <Link to="/admin" className="dropdown-item">
                                            <div className="icon-size-50 yellow-rounded-circle me-3">
                                                <Image loading="lazy" className="lazyload" src={Admin} width={25} height={28} alt="admin" />
                                            </div>
                                            <div>
                                                <p className="menu-text">Booking and dispatch</p>
                                                <span className="font-size-12 text-muted">Efficiently manage taxi business</span>
                                            </div>
                                        </Link>
                                    )} */}










                                </NavDropdown>
                                : null
                            }
                            {!yelowexpress ?
                                <NavDropdown
                                    title="Solutions"
                                    id="basic-nav-solutions"
                                    className="resources-menu mega-menu-business-type"
                                    show={showDropdownHover7}
                                    onMouseEnter={showDropdown7}
                                    onMouseLeave={hideDropdown7}
                                    onClick={showDropdown7}
                                >


                                    <Row xs={1} lg={2} className="g-0">
                                        <Col>
                                            <div className="border-end pe-lg-4 me-lg-4 equal-height">
                                                <h5 className="heading mb-0 mb-lg-4 d-flex p-3 p-lg-0 fw-medium">
                                                    Software
                                                </h5>
                                                {/* <Link to="/taxi-dispatch-platform" className="dropdown-item pb-3">
                                                    <div className="icon-size-50 yellow-rounded-circle me-3">
                                                        <Image loading="lazy" className="lazyload" src={Dispatch} width={28} height={28} alt="dispatch" />
                                                    </div>
                                                    <div>
                                                        <p className="font-size-16 mb-0">Taxi Dispatch</p>
                                                        <span className="font-size-12 text-muted">Streamline operations, fast bookings</span>
                                                    </div>
                                                </Link> */}
                                                <Link to="/taxi-dispatch-software" className="dropdown-item pb-3">
                                                    <div className="icon-size-50 yellow-rounded-circle me-3">
                                                        <Image loading="lazy" className="lazyload" src={Dispatch} width={28} height={28} alt="dispatch" />
                                                    </div>
                                                    <div>
                                                        <p className="font-size-16 mb-0">Taxi Dispatch Software</p>
                                                        <span className="font-size-12 text-muted">Manage rides faster, better, smarter</span>
                                                    </div>
                                                </Link>
                                                <Link to="/airport-taxi-transfer-software" className="dropdown-item pb-3">
                                                    <div className="icon-size-50 yellow-rounded-circle me-3">
                                                        <Image loading="lazy" className="lazyload" src={Airport} width={28} height={28} alt="airport" />
                                                    </div>
                                                    <div>
                                                        <p className="font-size-16 mb-0">Airport Transfer</p>
                                                        <span className="font-size-12 text-muted">Airport transfers made effortless</span>
                                                    </div>
                                                </Link>
                                                <Link to="/limo-dispatch-booking-software" className="dropdown-item pb-3">
                                                    <div className="icon-size-50 yellow-rounded-circle me-3">
                                                        <Image loading="lazy" className="lazyload" src={Limo} width={40} height={40} alt="rideHailing" />
                                                    </div>
                                                    <div>
                                                        <p className="font-size-16 mb-0">Limo Dispatch</p>
                                                        <span className="font-size-12 text-muted">Premium dispatch for VIP rides</span>
                                                    </div>
                                                </Link>
                                                <Link to="/corporate-taxi-booking-solution" className="dropdown-item pb-3">
                                                    <div className="icon-size-50 yellow-rounded-circle me-3">
                                                        <Image loading="lazy" className="lazyload" src={CorporateTransfer} width={28} height={28} alt="corporateTransfer" />
                                                    </div>
                                                    <div>
                                                        <p className="font-size-16 mb-0">Corporate Transport</p>
                                                        <span className="font-size-12 text-muted">Hassle-free transport for corporates</span>
                                                    </div>
                                                </Link>

                                                <Link to="/ride-hailing-software" className="dropdown-item pb-3">
                                                    <div className="icon-size-50 yellow-rounded-circle me-3">
                                                        <Image loading="lazy" className="lazyload" src={RideHailing} width={28} height={28} alt="rideHailing" />
                                                    </div>
                                                    <div>
                                                        <p className="font-size-16 mb-0">Ride Hailing</p>
                                                        <span className="font-size-12 text-muted">Build your own ride-hailing app</span>
                                                    </div>
                                                </Link>
                                                <Link to="/car-rental-software" className="dropdown-item pb-3">
                                                    <div className="icon-size-50 yellow-rounded-circle me-3">
                                                        <Image loading="lazy" className="lazyload" src={Rental} width={30} height={30} alt="rideHailing" />
                                                    </div>
                                                    <div>
                                                        <p className="font-size-16 mb-0">Car Rental</p>
                                                        <span className="font-size-12 text-muted">Your car rental system—digitized</span>
                                                    </div>
                                                </Link>
                                                <Link to="/school-bus-transportation-software" className="dropdown-item pb-3">
                                                    <div className="icon-size-50 yellow-rounded-circle me-3">
                                                        <Image loading="lazy" className="lazyload" src={Carerentalicon1} width={28} height={28} alt="rideHailing" />
                                                    </div>
                                                    <div>
                                                        <p className="font-size-16 mb-0">School Run</p>
                                                        <span className="font-size-12 text-muted">Manage school rides with ease</span>
                                                    </div>
                                                </Link>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="equal-height">
                                                <h5 className="heading mb-0 mb-lg-4 d-flex p-3 p-lg-0 fw-medium">
                                                    Use Cases
                                                </h5>
                                                <Link to="/chauffeur-limo-operator" className="dropdown-item pb-3">
                                                    <div className="icon-size-50 yellow-rounded-circle me-3">
                                                        <Image loading="lazy" className="lazyload" src={Limodriver} width={28} height={28} alt="dispatch" />
                                                    </div>
                                                    <div>
                                                        <p className="font-size-16 mb-0">Limo operator</p>
                                                        <span className="font-size-12 text-muted">Chauffeur software that does it all</span>
                                                    </div>
                                                </Link>
                                                <Link to="/ride-hailing-startup" className="dropdown-item pb-3">
                                                    <div className="icon-size-50 yellow-rounded-circle me-3">
                                                        <Image loading="lazy" className="lazyload" src={Startup} width={28} height={28} alt="airport" />
                                                    </div>
                                                    <div>
                                                        <p className="font-size-16 mb-0">Ride hailing startup</p>
                                                        <span className="font-size-12 text-muted">Start your ride-hailing business today</span>
                                                    </div>
                                                </Link>
                                                <Link to="/private-hire-operator" className="dropdown-item pb-3">
                                                    <div className="icon-size-50 yellow-rounded-circle me-3">
                                                        <Image loading="lazy" className="lazyload" src={Operators} width={28} height={28} alt="corporateTransfer" />
                                                    </div>
                                                    <div>
                                                        <p className="font-size-16 mb-0">Private hire</p>
                                                        <span className="font-size-12 text-muted">Automate operations for private hire</span>
                                                    </div>
                                                </Link>
                                                <div className="dropdown-item pb-3 non-link">
                                                    <div className="icon-size-50 yellow-rounded-circle me-3">
                                                        <Image loading="lazy" className="lazyload" src={Cab} width={30} height={30} alt="corporateTransfer" />
                                                    </div>
                                                    <div>
                                                        <p className="font-size-16 mb-0">Cab Companies</p>
                                                        <span className="font-size-12 text-muted">Digitize your cab business now</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                </NavDropdown>
                                : null
                            }
                            {!yelowexpress ?
                                <Link to="/features" className="nav-link">Features</Link>
                                : null
                            }
                            {yelowexpress ?
                                <NavDropdown
                                    title="Business Type"
                                    id="basic-nav-business-type"
                                    className={`mega-menu-business-type ${yelowtaxi ? "yelow-taxi-width" : yelowexpress ? "yelow-express-width" : ""}`}
                                    show={showDropdownHover2}
                                    onMouseEnter={showDropdown2}
                                    onMouseLeave={hideDropdown2}
                                    onClick={showDropdown2}
                                >
                                    <Row xs={1} lg={yelowexpress ? 2 : yelowtaxi ? 1 : 3} className="g-0">
                                        {!yelowexpress ?
                                            <Col>
                                                <div className={`equal-height ${yelowtaxi ? "" : "border-end pe-lg-4 me-lg-4"}`}>
                                                    <h5 className="heading mb-0 mb-lg-4 d-flex p-3 p-lg-0">
                                                        Dispatch solution
                                                    </h5>
                                                    <Link className="dropdown-item" to="/ride-hailing-software">Ride Hailing</Link>
                                                    <Link className="dropdown-item" to="/airport-taxi-transfer-software">Airport</Link>
                                                    <Link className="dropdown-item" to="/corporate-taxi-booking-solution">Corporate</Link>
                                                    <Link className="dropdown-item" to="/taxi-dispatch-platform">Taxi Dispatch</Link>
                                                    {/* <Link className="dropdown-item" to="/car-rental-software">Car Rental</Link> */}
                                                    <Link className="dropdown-item" to="/limo-dispatch-booking-software">Limo Dispatch</Link>
                                                </div>
                                            </Col> : null
                                        }
                                        {!yelowtaxi ?
                                            <>
                                                <Col>
                                                    <div className="border-end pe-lg-4 me-lg-4 equal-height">
                                                        <h5 className="heading mb-0 mb-lg-4 d-flex p-3 p-lg-0">
                                                            Food and Beverages
                                                        </h5>
                                                        <Link className="dropdown-item" to="/restaurant-ordering-and-delivery-solution">Restaurant</Link>
                                                        <Link className="dropdown-item" to="/pizza-ordering-delivery-platform">Pizza</Link>
                                                        <Link className="dropdown-item" to="/on-demand-delivery-software-for-cloud-kitchen">Cloud kitchen</Link>
                                                        <Link className="dropdown-item" to="/on-demand-delivery-software-for-cafe-and-coffee-shops">Cafes</Link>
                                                        <Link className="dropdown-item" to="/on-demand-delivery-software-for-bakeries">Bakeries</Link>
                                                        <Link className="dropdown-item" to="/on-demand-food-delivery-software-solution">Food Marketplace</Link>
                                                    </div>
                                                </Col>
                                                <Col>
                                                    <div className="ms-lg-4 equal-height">
                                                        <h5 className="heading mb-0 mb-lg-4 d-flex p-3 p-lg-0">
                                                            Retail
                                                        </h5>
                                                        <Link className="dropdown-item" to="/on-demand-grocery-delivery-software-solution">Grocery</Link>
                                                        <Link className="dropdown-item" to="/on-demand-meat-delivery-software">Meat</Link>
                                                        <Link className="dropdown-item" to="/online-milk-delivery-software">Milk</Link>
                                                        <Link className="dropdown-item" to="/on-demand-medicine-delivery-software-solution">Medicine</Link>
                                                        <Link className="dropdown-item" to="/on-demand-delivery-software-for-dark-stores">Dark Store</Link>
                                                        <Link className="dropdown-item" to="/on-demand-materials-delivery-software-solution">Materials</Link>
                                                        <Link className="dropdown-item" to="/home-kitchen-appliance-shop-management-software">Home & Kitchen</Link>
                                                        <Link className="dropdown-item" to="/beauty-cosmetic-shop-software">Beauty & Personal Care</Link>
                                                    </div>
                                                </Col>
                                            </> : null
                                        }
                                    </Row>
                                </NavDropdown>
                                : null
                            }

                            <NavDropdown title="Resources" id="basic-nav-resources"
                                show={showDropdownHover3}
                                onMouseEnter={showDropdown3}
                                onMouseLeave={hideDropdown3}
                                onClick={showDropdown3}
                                className="resources-menu"
                            >
                                <Link to="/blog" className="dropdown-item">
                                    <i className="resources-sprite-icon icon-1 icon-size-50 yellow-rounded-circle me-3"></i>
                                    <div>
                                        <p className="menu-text">Blog</p>
                                        <span className="font-size-12 text-muted">Get the latest insights</span>
                                    </div>
                                </Link>
                                <Link to="/product-update" className="dropdown-item">
                                    <i className="resources-sprite-icon icon-2 icon-size-50 yellow-rounded-circle me-3"></i>
                                    <div>
                                        <p className="menu-text">Product Update</p>
                                        <span className="font-size-12 text-muted">Discover our Products Range</span>
                                    </div>
                                </Link>
                                <Link to="/case-studies" className="dropdown-item">
                                    <i className="resources-sprite-icon icon-3 icon-size-50 yellow-rounded-circle me-3"></i>
                                    <div>
                                        <p className="menu-text">Case Studies</p>
                                        <span className="font-size-12 text-muted">How we helped our clients</span>
                                    </div>
                                </Link>

                                <Link to="/resources/video" className="dropdown-item">
                                    <i className="resources-sprite-icon icon-5 icon-size-50 yellow-rounded-circle me-3"></i>
                                    <div>
                                        <p className="menu-text">Video</p>
                                        <span className="font-size-12 text-muted">Explore product features</span>
                                    </div>
                                </Link>

                                <Link to="/e-book" className="dropdown-item">
                                    <i className="resources-sprite-icon icon-1 icon-size-50 yellow-rounded-circle me-3"></i>
                                    <div>
                                        <p className="menu-text">E-book</p>
                                        <span className="font-size-12 text-muted">Personalized Guide Book</span>
                                    </div>
                                </Link>
                                {/* <Link to="/whitepaper" className="dropdown-item">
                                    <i className="resources-sprite-icon icon-4 icon-size-50 yellow-rounded-circle me-3"></i>
                                    <div>
                                        <p className="menu-text">Whitepaper</p>
                                        <span className="font-size-12 text-muted">Checkout our whitepapers</span>
                                    </div>
                                </Link>
                                <Link to="/webinars" className="dropdown-item">
                                    <i className="resources-sprite-icon icon-5 icon-size-50 yellow-rounded-circle me-3"></i>
                                    <div>
                                        <p className="menu-text">Webinars</p>
                                        <span className="font-size-12 text-muted">Explore our Webinars</span>
                                    </div>
                                </Link> */}
                                <Link to="/integrations" className="dropdown-item">
                                    <i className="resources-sprite-icon icon-6 icon-size-50 yellow-rounded-circle me-3"></i>
                                    <div>
                                        <p className="menu-text">Integration</p>
                                        <span className="font-size-12 text-muted">Third Party Integrations</span>
                                    </div>
                                </Link>

                                <Link to="/testimonials" className="dropdown-item">
                                    <i className="resources-sprite-icon icon-5 icon-size-50 yellow-rounded-circle me-3"></i>
                                    <div>
                                        <p className="menu-text">Testimonials</p>
                                        <span className="font-size-12 text-muted">Explore our Testimonials</span>
                                    </div>
                                </Link>
                            </NavDropdown>
                            {
                                yelowexpress ?
                                    <Link to="/testimonials" className="nav-link">Testimonials</Link>
                                    : null
                            }
                            {
                                !yelowexpress ?
                                    <Link to="/pricing" className="nav-link">Pricing</Link>
                                    : null
                            }
                            <a href="/demo" className="btn btn-primary-theme-outline mt-4 d-block d-lg-none" aria-label="Book a demo" rel="noreferrer" target="_blank">
                                <span>Book a demo</span>
                            </a>
                            {yelowexpress ?
                                <Link to="/contact" className="btn btn-primary-theme mt-3 d-block d-lg-none"><span>Contact sales</span></Link>
                                :
                                <a href="https://service.yelowsoft.co/signup?pricing=3" className="btn btn-primary-theme mt-3 d-block d-lg-none" aria-label="Get Started Free" rel="noreferrer" target="_blank">
                                    <span>Get started free</span>
                                </a>
                            }
                            {/* <Dropdown as={Nav.Item} align="end">
                                <Dropdown.Toggle as={Nav.Link} id="basic-nav-language" className="d-flex align-items-center notranslate">
                                    <Image loading="lazy" className="lazyload rounded me-2" src={flagUpdate} alt={language} width={24} height={18} /> {language.toUpperCase()}
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="switcher notranslate">
                                    <div className="gtranslate-dropdown">
                                        <Link to="" className="dropdown-item d-flex align-items-center" onClick={(e) => { handleClick('ar'); setflagUpdate(flag.flagAr); }}>
                                            <Image loading="lazy" className="lazyload rounded me-2" src={flagAr} width={24} height={18} alt="ar" /> AR
                                        </Link>
                                        <Link to="" className="dropdown-item d-flex align-items-center" onClick={(e) => { handleClick('en'); setflagUpdate(flag.flagEn); }}>
                                            <Image loading="lazy" className="lazyload rounded me-2" src={flagEn} width={24} height={18} alt="en" /> EN
                                        </Link>
                                        <Link to="" className="dropdown-item d-flex align-items-center" onClick={(e) => { handleClick('fr'); setflagUpdate(flag.flagFr); }}>
                                            <Image loading="lazy" className="lazyload rounded me-2" src={flagFr} width={24} height={18} alt="fr" /> FR
                                        </Link>
                                        <Link to="" className="dropdown-item d-flex align-items-center" onClick={(e) => { handleClick('pt'); setflagUpdate(flag.flagPt); }}>
                                            <Image loading="lazy" className="lazyload rounded me-2" src={flagPt} width={24} height={18} alt="pt" /> PT
                                        </Link>
                                        <Link to="" className="dropdown-item d-flex align-items-center" onClick={(e) => { handleClick('es'); setflagUpdate(flag.flagEs); }}>
                                            <Image loading="lazy" className="lazyload rounded me-2" src={flagEs} width={24} height={18} alt="es" /> ES
                                        </Link>
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown> */}
                        </Nav>
                    </Navbar.Collapse>
                    <div className="right-menu-icon d-flex align-items-center ms-auto">
                        {/* <Dropdown
                            show={showDropdownHover4}
                            onMouseEnter={showDropdown4}
                            onMouseLeave={hideDropdown4}
                            onClick={showDropdown4}
                        >
                            <Dropdown.Toggle as="a" href="#" id="basic-nav-language" className="text-uppercase d-flex align-items-center topbar-link notranslate">
                                <div className="icon me-2">
                                    <i className="zmdi zmdi-hc-lg zmdi-globe-alt"></i>
                                </div>
                                {language}
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="switcher notranslate">
                                <div className="gtranslate-dropdown">
                                    <Link to="" className="dropdown-item d-flex align-items-center" onClick={(e) => { handleClick('ar'); }}>
                                        <Image loading="lazy" className="lazyload rounded me-2" src={flagAr} width={24} height={18} alt="ar" /> AR
                                    </Link>
                                    <Link to="" className="dropdown-item d-flex align-items-center" onClick={(e) => { handleClick('en'); }}>
                                        <Image loading="lazy" className="lazyload rounded me-2" src={flagEn} width={24} height={18} alt="en" /> EN
                                    </Link>
                                    <Link to="" className="dropdown-item d-flex align-items-center" onClick={(e) => { handleClick('fr'); }}>
                                        <Image loading="lazy" className="lazyload rounded me-2" src={flagFr} width={24} height={18} alt="fr" /> FR
                                    </Link>
                                    <Link to="" className="dropdown-item d-flex align-items-center" onClick={(e) => { handleClick('pt'); }}>
                                        <Image loading="lazy" className="lazyload rounded me-2" src={flagPt} width={24} height={18} alt="pt" /> PT
                                    </Link>
                                    <Link to="" className="dropdown-item d-flex align-items-center" onClick={(e) => { handleClick('es'); }}>
                                        <Image loading="lazy" className="lazyload rounded me-2" src={flagEs} width={24} height={18} alt="es" /> ES
                                    </Link>
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                        <a aria-label="Whatsapp Chat" title="Whatsapp Chat" href="https://wa.me/919725496144" rel="noreferrer" target="_blank" className="topbar-link d-none d-md-flex align-items-center text-whatsapp">
                            <div className="icon">
                                <i className="zmdi zmdi-hc-lg zmdi-whatsapp"></i>
                            </div>
                        </a>
                        <div role="button" title="Schedule Call" tabIndex="0" onClick={handleShowScheduleCall} onKeyDown={handleShowScheduleCall} className="topbar-link d-flex align-items-center">
                            <div className="icon">
                                <i className="zmdi zmdi-hc-lg zmdi-phone"></i>
                            </div>
                        </div> */}
                        {/* <Button onClick={handleShowScheduleCall} onKeyDown={handleShowScheduleCall} className="btn btn-primary-theme-outline ms-3 px-3 d-none d-lg-block"><span>Schedule demo</span></Button> */}
                        <a href="/demo" className="btn btn-primary-theme-outline ms-3 px-3 d-none d-lg-block" aria-label="Book a demo" rel="noreferrer" target="_blank">
                            <span>Book a demo</span>
                        </a>
                        {yelowexpress ?
                            <Link to="/contact" className="btn btn-primary-theme ms-3 px-3 d-none d-lg-block"><span>Get started free</span></Link>
                            :
                            <a href="https://service.yelowsoft.co/signup?pricing=3" className="btn btn-primary-theme ms-3 px-3 d-none d-lg-block" aria-label="Get Started Free" rel="noreferrer" target="_blank">
                                <span>Get started free</span>
                            </a>
                        }
                    </div>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" className="ms-3" />
                    <Navbar.Toggle className="nav-mobile-fixed" />
                </Container>
            </Navbar >
            {/* <Modal size="xl" show={showScheduleCall} onHide={handleCloseScheduleCall} centered backdrop="static" keyboard={false}>
                <Modal.Header className="flex-column border-0 0pt-4 0pt-lg-5 0pb-0 p-0 text-center" style={{ backgroundColor: '#f5f8fa' }}>
                    <h2 className="modal-title mb-3">Schedule Your Free Consultation</h2>
                    <p className="mb-0">Please select a date and time from the calendar below to schedule your free call.</p>
                    <div className="text-end video-close-btn">
                        <Button variant="" className="btn-close" onClick={handleCloseScheduleCall}></Button>
                    </div>
                </Modal.Header>
                <Modal.Body className="0pt-0 p-0" style={{ backgroundColor: "#f5f8fa" }}>
                    <div className="ratio ratio-16x9" style={{ minHeight: 500 }}>
                        <iframe className="lazyload" loading="lazy" width="100%" height="670" src="https://meetings.hubspot.com/mushahid1/website-integration" title="Schedule Call" frameBorder="0" allowFullScreen></iframe>
                    </div>
                </Modal.Body>
            </Modal> */}
        </>
    );
};

export default Header
